'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { List, Map as ImmutableMap } from 'immutable';
import BookingFormField from './BookingFormField';
import PropTypes from 'prop-types';
import { propertyLabelTranslator } from 'property-translator/propertyTranslator';
var displayName = 'CustomFormInputs';
var propTypes = {
  formFields: PropTypes.instanceOf(List).isRequired,
  customFormFields: PropTypes.instanceOf(ImmutableMap).isRequired,
  onCustomFormFieldChange: PropTypes.func.isRequired,
  formStateValidation: PropTypes.instanceOf(ImmutableMap).isRequired,
  disabled: PropTypes.bool
};

var CustomFormInputs = function CustomFormInputs(_ref) {
  var formFields = _ref.formFields,
      customFormFields = _ref.customFormFields,
      onCustomFormFieldChange = _ref.onCustomFormFieldChange,
      formStateValidation = _ref.formStateValidation,
      disabled = _ref.disabled;
  return /*#__PURE__*/_jsx("div", {
    style: {
      wordWrap: 'break-word'
    },
    children: formFields.map(function (field) {
      return /*#__PURE__*/_jsx(BookingFormField, {
        fieldValue: customFormFields.get(field.name),
        fieldName: field.name,
        validation: formStateValidation.get(field.name),
        setFormValue: onCustomFormFieldChange,
        type: field.type,
        fieldType: field.fieldType,
        isRequired: field.isRequired,
        fieldLabel: propertyLabelTranslator(field.label),
        fieldOptions: field.options,
        fieldIsCustom: field.isCustom,
        numberDisplayHint: field.numberDisplayHint,
        disabled: disabled
      }, "" + field.name);
    })
  });
};

CustomFormInputs.displayName = displayName;
CustomFormInputs.propTypes = propTypes;
export default CustomFormInputs;